import React from 'react'
import loadingimg from '../../assets/images/Ioading-spinner.gif'

export default function Loader(props) {
  return (
    props.loadingStatus && <div className='loader d-flex align-items-center justify-content-center text-center'>
        <img src={loadingimg} alt='loading' />
    </div>
  )
}

Loader.defaultProps = {
  loadingStatus: false
}
